import styles from './AmbientBackground.module.css';

export const AmbientBackground = () => {
  return (
    <>
      <div className={styles.ambientBg}>
        <div className={`${styles.ambientOrb} ${styles.orb1}`}></div>
        <div className={`${styles.ambientOrb} ${styles.orb2}`}></div>
        <div className={`${styles.ambientOrb} ${styles.orb3}`}></div>
      </div>
      <div className={styles.gridOverlay}></div>
    </>
  );
};
